import g from "./globals";
import mode from "./mode";
import Logger from "./Logger";

const logger = new Logger(__filename);

export const queryDevice = () => {
  if (g.developerMode) {
    let fake = {};
    if (mode.query.device) {
      if (mode.query.device === "ipadv") {
        fake = {
          channel: "desktop",
          deviceOrientation: "portrait",
          channels: {
            ipad: true,
            desktop: false,
            mobile: false,
            apps: false,
          },
          isTablet: true,
        };
        logger.log("QUERY STRING DEVICE: IPADV");
      } else if (mode.query.device === "ipadh" || mode.query.device === "ipad") {
        fake = {
          channel: "desktop",
          deviceOrientation: "landscape",
          channels: {
            ipad: true,
            desktop: false,
            mobile: false,
            apps: false,
          },
          isTablet: true,
        };
        logger.log("QUERY STRING DEVICE: IPADH");
      } else if (mode.query.device === "mobile") {
        fake = {
          channel: "mobile",
          deviceOrientation: "landscape",
          channels: {
            ipad: false,
            desktop: false,
            mobile: true,
            apps: false,
          },
          isTablet: false,
        };
        logger.log("QUERY STRING DEVICE: MOBILE");
      } else if (mode.query.device === "apps") {
        fake = {
          channel: "apps",
          deviceOrientation: "portrait",
          channels: {
            ipad: false,
            desktop: false,
            mobile: false,
            apps: true,
          },
          isTablet: false,
        };
        logger.log("QUERY STRING DEVICE: APP MOBILE");
      }
    }
    g.setGlobals(fake);
  }
};
